import React, { Component } from 'react'
import PropTypes from 'prop-types'

class RiderTableEmbeddingModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      roles: null,
      email: null
    }
  }

  render() {
    return (
      <div className="modal modal-full">
        <label>Previewing {this.props.title}</label>
        <iframe src={this.props.url} width="100%" height="60%" frameBorder="0" />

        <ul className="group">
          <li>
            <span className="unit" data-title="Use this on your website:">
              <textarea rows="2" defaultValue={`<iframe src="${this.props.url}" width="100%" height="100%" frameBorder="0" />`} />
            </span>
          </li>

          <li>
            <button onClick={() => this.props.setModal(false)}>Close</button>
          </li>
        </ul>
      </div>
    )
  }
}

RiderTableEmbeddingModal.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  setModal: PropTypes.func
}

RiderTableEmbeddingModal.defaultProps = {
  title: '',
  url: '',
  setModal: function() {}
}

export default RiderTableEmbeddingModal



// WEBPACK FOOTER //
// ./src/components/modals/rider-table-embedding-modal.js